const BASE_URL = 'http://localhost:5001/api';

const getToken = () => localStorage.getItem('token');

const headers = () => ({
  'Content-Type': 'application/json',
  ...(getToken() && { Authorization: `Bearer ${getToken()}` }),
});

const request = async (method, endpoint, body = null) => {
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method,
    headers: headers(),
    ...(body && { body: JSON.stringify(body) }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
};

// Auth
export const register = (data) => request('POST', '/auth/register', data);
export const login    = (data) => request('POST', '/auth/login', data);
export const getMe    = ()     => request('GET',  '/auth/me');
export const updateProfile = (data) => request('PUT', '/auth/update', data);

// Jobs
export const getJobs   = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return request('GET', `/jobs?${query}`);
};
export const getJob    = (id)   => request('GET',    `/jobs/${id}`);
export const createJob = (data) => request('POST',   '/jobs', data);
export const updateJob = (id, data) => request('PUT', `/jobs/${id}`, data);
export const deleteJob = (id)   => request('DELETE', `/jobs/${id}`);
export const applyJob  = (id, data) => request('POST', `/jobs/${id}/apply`, data);
export const getJobApplications = (id) => request('GET', `/jobs/${id}/applications`);

// Applications
export const getMyApplications = () => request('GET', '/applications/my');
export const updateAppStatus   = (id, status) => request('PUT', `/applications/${id}/status`, { status });
export const withdrawApplication = (id) => request('DELETE', `/applications/${id}`);

// Users
export const getSavedJobs  = ()   => request('GET',  '/users/saved-jobs');
export const toggleSaveJob = (id) => request('POST', `/users/save-job/${id}`);

// Contact
export const sendContact = (data) => request('POST', '/contact', data);
